import { useCallback, useMemo, useState } from "react";
import "@pulse-ui/styling/pulse-wave-lib/components/ag-theme-pulse.css";

// Component Imports
import { DebouncedInput } from "../Inputs";
import AGLoadingOverlay from "../AGOverlays/AGLoadingOverlay/AGLoadingOverlay";

// Package Imports
import { AgGridReact } from "ag-grid-react";

// Type/Lib Imports
import {
  ModuleRegistry,
  QuickFilterModule,
  SizeColumnsToContentStrategy,
  themeAlpine,
} from "ag-grid-community";

ModuleRegistry.registerModules([QuickFilterModule]);

const SocketAGTable = ({
  gridRef,
  rowData,
  colDefs,
  defaultColDef,
  loading,
}: {
  gridRef: any;
  rowData: any;
  colDefs: any;
  defaultColDef: any;
  loading?: boolean;
}) => {
  const [quickFilterText, setQuickFilterText] = useState<string>("");

  const containerStyle = useMemo(() => ({ height: 800, overflow: "auto" }), []);

  const autoSizeStrategy: SizeColumnsToContentStrategy = {
    type: "fitCellContents",
  };
  const getRowId = useCallback((params: any) => params.data.row_id, []);

  return (
    <>
      <div className="pulse-row pulse-mb-1">
        <div className="pulse-search-input open-orders-position-relative pulse-display-f pulse-justify-flex-start pulse-col-md-6 pulse-col-lg-6 pulse-col-xl-6">
          <DebouncedInput
            value={quickFilterText || ""}
            debounce={500}
            onChange={setQuickFilterText}
            placeholder="Search all rows..."
            classNames="pulse-debounced-input pulse-br-sm pulse-bg-color--background-800 pulse-color--background-600 pulse-typography-body-2"
          />
        </div>
      </div>

      <div className="ag-theme-alpine ag-theme-pulse" style={containerStyle}>
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          autoSizeStrategy={autoSizeStrategy}
          animateRows={false}
          getRowId={getRowId}
          suppressMoveWhenColumnDragging
          overlayNoRowsTemplate="No rows to display."
          quickFilterText={quickFilterText}
          loading={loading}
          loadingOverlayComponent={AGLoadingOverlay}
          theme={themeAlpine}
        />
      </div>
    </>
  );
};

export default SocketAGTable;
